import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'parseDate'})
export class ParseDate implements PipeTransform {
    transform(val: any) {
        return new Date(val);
    }
}